import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

import LoadingCircle from "../../../../components/loadingCircle/LoadingCircle";
import { dashboardTags } from "../../../../config/tagList";
import useInboundDeliveriesCountsQuery from "../../../../hooks/graphql-hooks/queries/useInboundDeliveriesCountsQuery";
import useNavigateTo from "../../../../hooks/useNavigateTo";
import { DeliveryCount } from "../../../../models/deliveryCount";
import { TagName } from "../../../../models/tag";
import YourDeliveriesCards from "../../components/yourDeliveriesCards/YourDeliveriesCards";
import YourDeliveriesHeadline from "../../components/yourDeliveriesHeadline/YourDeliveriesHeadline";
import "./YourDeliveriesSection.scss";

interface YourDeliveriesSectionProps {
  deliveryCount: DeliveryCount[];
  setDeliveryCount: (count: DeliveryCount) => void;
}

const YourDeliveriesSection = (props: YourDeliveriesSectionProps) => {
  const { t } = useTranslation();
  const { navigateToDeliveries } = useNavigateTo();
  const { deliveryCount, setDeliveryCount } = props;

  const allDeliveriesTag = dashboardTags.find(
    (tag) => tag.name === TagName.AllDeliveries,
  );

  const allDeliveriesCount =
    deliveryCount.find((count) => count.key === TagName.AllDeliveries)?.value ||
    0;

  const { loading } = useInboundDeliveriesCountsQuery({
    variables: {
      plannedDeliveryDateFilter:
        allDeliveriesTag?.inputParameters?.plannedDeliveryDateFilter || null,
      plannedDeliveryDateFilterMatch:
        allDeliveriesTag?.inputParameters?.plannedDeliveryDateFilterMatch ||
        null,
    },
    dataAction: (count) =>
      setDeliveryCount({ key: TagName.AllDeliveries, value: count }),
  });

  return (
    <div data-testid="your-deliveries-section" className="section-container">
      <div className="section-container-headline">
        <YourDeliveriesHeadline count={allDeliveriesCount} />
      </div>
      <YourDeliveriesCards
        deliveryCount={deliveryCount}
        setDeliveryCount={setDeliveryCount}
      />
      <div className="section-container-button">
        <Button variant="contained" onClick={() => navigateToDeliveries()}>
          <div className="section-container-button-text">
            {t("allDeliveries")}
          </div>
          {loading ? (
            <LoadingCircle />
          ) : (
            <div className="section-container-button-count">
              {allDeliveriesCount}
            </div>
          )}
        </Button>
      </div>
    </div>
  );
};

export default YourDeliveriesSection;
